import { render, staticRenderFns } from "./Top5Mobile.vue?vue&type=template&id=6817f7a8&scoped=true&"
import script from "./Top5Mobile.vue?vue&type=script&lang=js&"
export * from "./Top5Mobile.vue?vue&type=script&lang=js&"
import style0 from "./Top5Mobile.vue?vue&type=style&index=0&id=6817f7a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6817f7a8",
  null
  
)

export default component.exports